export default "__VITE_ASSET__CGomFG35__"